import {
  Modal,
  Stack,
  Text,
  Group,
  Button,
  Alert,
  Divider,
} from "@mantine/core";
import {
  IconAlertTriangle,
  IconExternalLink,
  IconArrowRight,
} from "@tabler/icons-react";

interface PendingDiscussionsModalProps {
  opened: boolean;
  onClose: () => void;
  onGoToDiscussion: () => void;
  onSignOffAnyway: () => void;
  pendingCount: number;
}

export function PendingDiscussionsModal({
  opened,
  onClose,
  onGoToDiscussion,
  onSignOffAnyway,
  pendingCount,
}: PendingDiscussionsModalProps) {
  return (
    <Modal.Root
      opened={opened}
      onClose={onClose}
      size="lg"
      centered
      styles={{
        content: {
          display: "flex",
          flexDirection: "column",
          maxHeight: "85vh",
        },
      }}
    >
      <Modal.Overlay />
      <Modal.Content>
        <Modal.Header>
          <Modal.Title>
            <Group gap="xs">
              <IconAlertTriangle
                size={20}
                color="var(--mantine-color-orange-6)"
              />
              <span>Pending Discussions</span>
            </Group>
          </Modal.Title>
          <Modal.CloseButton />
        </Modal.Header>

        <Modal.Body style={{ flex: 1, overflowY: "auto" }}>
          <Stack gap="md">
            <Alert color="orange" icon={<IconAlertTriangle size={20} />}>
              <Text size="sm">
                There {pendingCount === 1 ? "is" : "are"}{" "}
                <strong>{pendingCount}</strong> pending discussion
                {pendingCount !== 1 ? "s" : ""} that{" "}
                {pendingCount === 1 ? "has" : "have"} not been resolved. You can
                review and resolve them, or sign off anyway.
              </Text>
            </Alert>
          </Stack>
        </Modal.Body>

        <Divider />
        <Group justify="space-between" p="md">
          <Button size="sm" variant="default" onClick={onClose}>
            Cancel
          </Button>
          <Group gap="sm">
            <Button
              size="sm"
              variant="light"
              color="grape"
              leftSection={<IconExternalLink size={16} />}
              onClick={onGoToDiscussion}
            >
              Go to Discussions
            </Button>
            <Button
              size="sm"
              color="red"
              rightSection={<IconArrowRight size={16} />}
              onClick={onSignOffAnyway}
            >
              Sign Off Anyway
            </Button>
          </Group>
        </Group>
      </Modal.Content>
    </Modal.Root>
  );
}
